/**
 * Fatal boot failures, shown rather than swallowed.
 *
 * The app boots its content before the UI mounts, so a failure there used to
 * land as an unhandled rejection in the console while the microsite rendered as
 * if nothing was wrong. That reads as "works, but the AR is broken", which is
 * the worst way to find out the artwork cache was never pulled down.
 */

/** Replace the page with the error, so a broken boot cannot look like a working one. */
export const renderFatalBootError = (error: unknown): void => {
  const message = error instanceof Error ? error.message : String(error);
  console.error(message);

  if (typeof document === "undefined") return;

  const panel = document.createElement("pre");
  panel.setAttribute("role", "alert");
  panel.textContent = message;
  Object.assign(panel.style, {
    position: "fixed",
    inset: "0",
    zIndex: "2147483647",
    margin: "0",
    padding: "24px",
    overflow: "auto",
    background: "#1b1b1b",
    color: "#ffd7d7",
    font: "13px/1.6 ui-monospace, SFMono-Regular, Menlo, monospace",
    whiteSpace: "pre-wrap",
  } satisfies Partial<CSSStyleDeclaration>);

  const paint = () => document.body?.appendChild(panel);
  if (document.body) paint();
  else document.addEventListener("DOMContentLoaded", paint, { once: true });
};
